/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: npm run preprocess:generate-new
 * Generated at: 2026-05-06T00:55:53.833Z
 *
 * Index of Hebrew training sections
 * Use lazy imports to load section data on demand
 */

export interface SectionMetadata {
  id: string;
  title: string;
  description: string;
  introducedChars: string[];
  isPrerequisite: boolean;
  prerequisites: string[];
  classCount: number;
  fileName: string;
}

export const hebrewSectionsMetadata: SectionMetadata[] = [
  {
    "id": "hebrew-home-row",
    "title": "Home Row",
    "description": "Master the home row with balanced left-right hand pairs",
    "introducedChars": [
      "כ",
      "ח",
      "ג",
      "ל",
      "ד",
      "ך",
      "ש",
      "ף"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 7,
    "fileName": "section-1-home-row.ts"
  },
  {
    "id": "hebrew-top-row",
    "title": "Top Row",
    "description": "Reach up from home row with balanced pairs",
    "introducedChars": [
      "ר",
      "ו",
      "ק",
      "ן",
      "'",
      "ם",
      "/",
      "פ"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 15,
    "fileName": "section-2-top-row.ts"
  },
  {
    "id": "hebrew-bottom-row",
    "title": "Bottom Row",
    "description": "Reach down from home row with balanced pairs",
    "introducedChars": [
      "ה",
      "צ",
      "ב",
      "ת",
      "ס",
      "ץ",
      "ז",
      "."
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 18,
    "fileName": "section-3-bottom-row.ts"
  },
  {
    "id": "hebrew-middle-keys",
    "title": "Middle Keys",
    "description": "Index finger reaches inward to middle columns",
    "introducedChars": [
      "ע",
      "י",
      "א",
      "ט",
      "נ",
      "מ"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 10,
    "fileName": "section-4-middle-keys.ts"
  },
  {
    "id": "hebrew-numbers",
    "title": "Numbers",
    "description": "Number row 0-9 with balanced left-right pairs",
    "introducedChars": [
      "5",
      "6",
      "4",
      "7",
      "3",
      "8",
      "2",
      "9",
      "1",
      "0"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 9,
    "fileName": "section-5-numbers.ts"
  }
];

/**
 * Lazy-load a section by ID.
 * Uses an explicit switch with static import paths so Vite can statically
 * analyze and code-split each section bundle.
 */
export async function loadHebrewSection(sectionId: string) {
  switch (sectionId) {
    case 'hebrew-home-row':
      return (await import('./section-1-home-row')).section;
    case 'hebrew-top-row':
      return (await import('./section-2-top-row')).section;
    case 'hebrew-bottom-row':
      return (await import('./section-3-bottom-row')).section;
    case 'hebrew-middle-keys':
      return (await import('./section-4-middle-keys')).section;
    case 'hebrew-numbers':
      return (await import('./section-5-numbers')).section;
    default:
      throw new Error(`Section not found: ${sectionId}`);
  }
}
